"use client";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { GuidesSectionContent, Feature } from "./content";
import { GuidesSectionError } from "./error";
import { GuidesSectionLoading } from "./loading";
import { GuidesSearchContent } from "./search-content";

export function GuidesSection({ feature }: { feature: Feature }) {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <GuidesSectionError
          error={error as Error}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
      onError={(error, errorInfo) => {
        console.error("TransactionList Error:", error, errorInfo);
      }}
      onReset={() => {
        console.log("TransactionList error boundary reset");
      }}
    >
      <Suspense fallback={<GuidesSectionLoading />}>
        <GuidesSectionContent feature={feature} />
      </Suspense>
    </ErrorBoundary>
  );
}

export function GuidesSearchSection({ searchQuery }: { searchQuery: string }) {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <GuidesSectionError
          error={error as Error}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
      onError={(error, errorInfo) => {
        console.error("TransactionList Error:", error, errorInfo);
      }}
      onReset={() => {
        console.log("TransactionList error boundary reset");
      }}
    >
      <Suspense fallback={<GuidesSectionLoading />}>
        <GuidesSearchContent searchQuery={searchQuery} />
      </Suspense>
    </ErrorBoundary>
  );
}
